import { useState } from "react";
import { LoaderFunctionArgs, redirect, useFetcher, useLoaderData, useParams } from "react-router-dom";
import { doFetch } from "../../utils/doFetch";
import { DoaForecastStats } from "./DoaForecastStats";
import { IDoaForecastStatsData } from "./DoaForecastStatsData";

export const doaForecastStatsRouteLoader = async ({ request, params }: LoaderFunctionArgs) => {
  const { dispatch, date } = params;
  let error = null;
  let data: IDoaForecastStatsData | null = null;
  if (dispatch && date) {
    try {
      data = await doFetch(`doa-forecast/${dispatch}/${date}/stats`, { signal: request.signal }, true, false);
    } catch (err) {
      error = err
    }
  }
  if (error && dispatch && date) {
    return redirect(`/doa-forecast`);
  }
  return data;
}

export const DoaForecastStatsRoute = () => {
  const fetcher = useFetcher();
  const loaderData = useLoaderData();
  const params = useParams();
  const data = fetcher.data as IDoaForecastStatsData ?? loaderData as IDoaForecastStatsData;
  const onRefresh = () => fetcher.load(`/doa-forecast-stats/${params.dispatch}/${params.date}`);
  const loading = fetcher.state === 'loading';
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  return <DoaForecastStats
    loading={loading}
    onRefresh={onRefresh}
    data={data}
    showDisclaimer={showDisclaimer}
    onShowDisclaimer={() => setShowDisclaimer(prev => !prev)}
  />
}